(function () {
  function initGallery(root) {
    var nav = root.querySelector('[data-product-thumbs]');
    if (!nav) return;
    var scroller = nav.querySelector('.product__thumbs--scroller');
    var items = Array.from(nav.querySelectorAll('.product__thumb-item'));
    var arrows = Array.from(nav.querySelectorAll('.product__thumb-arrow'));
    var visible = [];
    var selected = -1;
    var frame;
    function key(item) {
      var link = item.querySelector('a');
      // Keep video/model entries distinct even if their poster matches an image.
      return item.querySelector('.product__thumb-icon') ? link.dataset.id : link.href.split('?')[0];
    }
    function sync() {
      var seen = new Map();
      var active = items.find(function (item) { return !item.classList.contains('hide') && item.querySelector('a.is-active'); });
      visible = [];
      items.forEach(function (item) {
        var duplicate = !item.classList.contains('hide') && seen.has(key(item));
        item.toggleAttribute('data-gallery-duplicate', duplicate);
        if (!item.classList.contains('hide') && !duplicate) {
          seen.set(key(item), item);
          visible.push(item);
        }
      });
      var representative = active && seen.get(key(active));
      selected = visible.indexOf(representative);
      items.forEach(function (item, index) {
        var link = item.querySelector('a');
        var isActive = item === representative;
        link.toggleAttribute('data-gallery-active', isActive);
        link.setAttribute('aria-current', isActive ? 'true' : 'false');
        link.setAttribute('aria-label', 'View product media ' + (index + 1));
      });
      var slots = window.matchMedia('(max-width: 768px)').matches ? 3 : 4;
      arrows.forEach(function (arrow, index) {
        arrow.hidden = visible.length <= slots;
        arrow.disabled = index === 0 ? selected <= 0 : selected >= visible.length - 1;
        arrow.setAttribute('aria-label', index === 0 ? 'Previous product image' : 'Next product image');
      });
      if (representative) {
        var left = representative.offsetLeft;
        var right = left + representative.offsetWidth;
        if (left < scroller.scrollLeft) scroller.scrollLeft = left;
        else if (right > scroller.scrollLeft + scroller.clientWidth) scroller.scrollLeft = right - scroller.clientWidth;
      }
    }
    // Delegate selection to the native thumbnail handler, retaining image-set indices.
    nav.addEventListener('click', function (event) {
      var arrow = event.target.closest('.product__thumb-arrow');
      if (!arrow) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      sync();
      var next = selected + (arrow.classList.contains('product__thumb-arrow--prev') ? -1 : 1);
      if (visible[next]) visible[next].querySelector('a').click();
    }, true);
    var observer = new MutationObserver(function () {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(sync);
    });
    // Native selection and variant image-set filtering both update these classes.
    observer.observe(scroller, { subtree: true, attributes: true, attributeFilter: ['class'] });
    var resize = new ResizeObserver(sync);
    resize.observe(scroller);
    function unload(event) {
      if (!event.target.contains(root)) return;
      observer.disconnect();
      resize.disconnect();
      cancelAnimationFrame(frame);
      document.removeEventListener('shopify:section:unload', unload);
    }
    document.addEventListener('shopify:section:unload', unload);
    sync();
  }
  function init(root) {
    if (!root || root.dataset.barefootReady === 'true') return;
    root.dataset.barefootReady = 'true';
    initGallery(root);
    var swatchMapElement = root.querySelector('[data-barefoot-swatch-map]');
    var swatchMap = swatchMapElement ? JSON.parse(swatchMapElement.textContent) : {};
    var variantJson = root.querySelector('[data-variant-json]');
    var variants = variantJson ? JSON.parse(variantJson.value || variantJson.textContent) : [];
    root.querySelectorAll('.variant-input[data-value]').forEach(function (wrapper) {
      var input = wrapper.querySelector('.variant__input--color-swatch');
      var label = wrapper.querySelector('.color-swatch');
      if (!input || !label) return;

      var colorOptionIndex = parseInt(input.dataset.colorIndex, 10);
      var imageVariant = variants.find(function (variant) {
        var hasFeaturedImage = variant.featured_image && variant.featured_image.src;
        var hasPreviewImage = variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src;
        return variant.options && variant.options[colorOptionIndex] === input.value && (hasFeaturedImage || hasPreviewImage);
      });
      if (imageVariant) {
        var image = imageVariant.featured_image && imageVariant.featured_image.src ? imageVariant.featured_image : imageVariant.featured_media.preview_image;
        var imageUrl = image.src;
        if (imageUrl.indexOf('//') === 0) imageUrl = 'https:' + imageUrl;
        imageUrl += imageUrl.indexOf('?') === -1 ? '?width=100' : '&width=100';
        label.style.backgroundImage = 'url("' + imageUrl.replace(/"/g, '\\"') + '")';
        return;
      }

      var nativeImage = label.style.backgroundImage;
      if (nativeImage && nativeImage !== 'none') return;

      var optionValue = (wrapper.dataset.value || input.value || '').trim().toLowerCase();
      if (swatchMap[optionValue]) {
        label.style.setProperty('--barefoot-swatch-fill', swatchMap[optionValue]);
        label.style.backgroundColor = swatchMap[optionValue];
      }
    });
    var addToCartText = root.dataset.barefootAtcLabel;
    var addToCartLabel = root.querySelector('[data-add-to-cart-text]');
    if (addToCartText && addToCartLabel) {
      addToCartLabel.dataset.defaultText = addToCartText;
      if (!addToCartLabel.closest('button').disabled) addToCartLabel.textContent = addToCartText;
    }
    var productSelect = root.querySelector('[data-product-select]');
    var addToCartButton = root.querySelector('[data-add-to-cart]');
    var inventoryMapElement = root.querySelector('[data-barefoot-inventory-map]');
    var inventoryMap = inventoryMapElement ? JSON.parse(inventoryMapElement.textContent) : {};
    var lowStock = root.querySelector('[data-barefoot-low-stock]');
    var lowStockText = lowStock ? lowStock.querySelector('[data-barefoot-low-stock-text]') : null;

    root.querySelectorAll('[data-barefoot-offer]').forEach(function (offer) {
      var track = offer.querySelector('[data-barefoot-offer-track]');
      var slides = offer.querySelectorAll('[data-barefoot-offer-slide]');
      var dots = offer.querySelectorAll('[data-barefoot-offer-dot]');
      var index = 0;
      var timer = null;
      var pointerStart = null;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!track || slides.length < 2) return;

      function show(nextIndex) {
        index = (nextIndex + slides.length) % slides.length;
        track.style.transform = 'translate3d(-' + (index * 100) + '%, 0, 0)';
        slides.forEach(function (slide, slideIndex) {
          slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
        });
        dots.forEach(function (dot, dotIndex) {
          var active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      function start() {
        stop();
        if (!reduceMotion) timer = window.setInterval(function () {
          if (!root.isConnected) { stop(); return; }
          show(index + 1);
        }, 4000);
      }

      dots.forEach(function (dot, dotIndex) {
        dot.addEventListener('click', function () { show(dotIndex); start(); });
      });
      offer.addEventListener('mouseenter', stop);
      offer.addEventListener('mouseleave', start);
      offer.addEventListener('focusin', stop);
      offer.addEventListener('focusout', start);
      offer.addEventListener('pointerdown', function (event) { pointerStart = event.clientX; });
      offer.addEventListener('pointerup', function (event) {
        if (pointerStart === null) return;
        var distance = event.clientX - pointerStart;
        pointerStart = null;
        if (Math.abs(distance) < 35) return;
        show(index + (distance < 0 ? 1 : -1));
        start();
      });
      offer.addEventListener('pointercancel', function () { pointerStart = null; });
      show(0);
      start();
    });

    root.querySelectorAll('[data-barefoot-addon-card]').forEach(function (card) {
      var variantsElement = card.querySelector('[data-barefoot-addon-variants]');
      var addonVariants = variantsElement ? JSON.parse(variantsElement.textContent) : [];
      var colorIndex = parseInt(card.dataset.colorIndex, 10);
      var sizeIndex = parseInt(card.dataset.sizeIndex, 10);
      var colorInputs = card.querySelectorAll('[data-barefoot-addon-color]');
      var sizeSelect = card.querySelector('[data-barefoot-addon-size]');
      var variantInput = card.querySelector('[data-barefoot-addon-variant]');
      var image = card.querySelector('[data-barefoot-addon-image]');
      var price = card.querySelector('[data-barefoot-addon-price]');
      var comparePrice = card.querySelector('[data-barefoot-addon-compare]');
      var button = card.querySelector('.barefoot-addon__button');

      if (!addonVariants.length || !sizeSelect || !variantInput || !button) return;

      function selectedColor() {
        var checked = card.querySelector('[data-barefoot-addon-color]:checked');
        return checked ? checked.value : '';
      }

      function formatMoney(value) {
        if (window.theme && theme.Currency && theme.settings.moneyFormat) {
          return theme.Currency.formatMoney(value, theme.settings.moneyFormat);
        }
        return (value / 100).toFixed(2);
      }

      function updateSizeOptions(preferredSize) {
        var color = selectedColor();
        var sizes = [];
        addonVariants.forEach(function (variant) {
          if (!variant.available || variant.options[colorIndex] !== color) return;
          var value = variant.options[sizeIndex];
          if (sizes.indexOf(value) === -1) sizes.push(value);
        });

        sizeSelect.innerHTML = '';
        sizes.forEach(function (value) {
          var option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          sizeSelect.appendChild(option);
        });
        if (preferredSize && sizes.indexOf(preferredSize) !== -1) sizeSelect.value = preferredSize;
      }

      function matchingVariant() {
        var color = selectedColor();
        var size = sizeSelect.value;
        return addonVariants.find(function (variant) {
          return variant.available && variant.options[colorIndex] === color && variant.options[sizeIndex] === size;
        }) || null;
      }

      function renderVariant() {
        var variant = matchingVariant();
        button.disabled = !variant;
        variantInput.value = variant ? variant.id : '';
        button.textContent = variant ? button.dataset.defaultText : (window.theme && theme.strings ? theme.strings.soldOut : 'Sold out');
        if (!variant) return;

        if (price) price.textContent = formatMoney(variant.price);
        if (comparePrice) {
          var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
          comparePrice.hidden = !onSale;
          comparePrice.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
        }
        if (image && variant.featured_image && variant.featured_image.src) {
          var imageUrl = variant.featured_image.src;
          if (imageUrl.indexOf('//') === 0) imageUrl = 'https:' + imageUrl;
          image.removeAttribute('srcset');
          image.src = imageUrl + (imageUrl.indexOf('?') === -1 ? '?width=520' : '&width=520');
        }
      }

      colorInputs.forEach(function (input) {
        var colorAvailable = addonVariants.some(function (variant) {
          return variant.available && variant.options[colorIndex] === input.value;
        });
        input.disabled = !colorAvailable;
        var swatchLabel = card.querySelector('label[for="' + input.id + '"]');
        if (swatchLabel) swatchLabel.classList.toggle('is-disabled', !colorAvailable);
        input.addEventListener('change', function () {
          updateSizeOptions(sizeSelect.value);
          renderVariant();
        });
      });
      var checkedColor = card.querySelector('[data-barefoot-addon-color]:checked');
      if (checkedColor && checkedColor.disabled) {
        var firstAvailableColor = card.querySelector('[data-barefoot-addon-color]:not(:disabled)');
        if (firstAvailableColor) firstAvailableColor.checked = true;
      }
      sizeSelect.addEventListener('change', renderVariant);
      updateSizeOptions(sizeSelect.value);
      renderVariant();
    });

    root.querySelectorAll('.barefoot-addon__form').forEach(function (form) {
      if (form.dataset.barefootAjaxReady === 'true') return;
      if (!window.theme || theme.settings.cartType !== 'drawer' || !theme.AjaxProduct) return;
      form.dataset.barefootAjaxReady = 'true';
      new theme.AjaxProduct(form, '.barefoot-addon__button');
    });

    function updateLowStock(variant) {
      if (!lowStock) return;
      var enabled = lowStock.dataset.enabled === 'true';
      var threshold = parseInt(lowStock.dataset.threshold, 10) || 0;
      var inventory = variant ? inventoryMap[String(variant.id)] : null;
      var reliable = inventory && inventory.policy !== 'continue';
      var quantity = reliable ? Number(inventory.quantity) : 0;
      var isLow = enabled && reliable && quantity > 0 && quantity <= threshold;
      var useFallback = !reliable && lowStock.dataset.fallbackEnabled === 'true';

      lowStock.hidden = !(isLow || useFallback);
      if (lowStockText) lowStockText.textContent = isLow ? lowStock.dataset.lowText : lowStock.dataset.fallbackText;
    }

    function initDispatchDate() {
      var dispatch = root.querySelector('[data-barefoot-dispatch]');
      if (!dispatch) return;
      var output = dispatch.querySelector('[data-barefoot-dispatch-date]');
      var days = Math.max(0, parseInt(dispatch.dataset.days, 10) || 0);
      var businessDays = dispatch.dataset.businessDays === 'true';
      var format = dispatch.dataset.dateFormat;
      var lastDateKey = '';

      function renderDate() {
        var now = new Date();
        var dateKey = [now.getFullYear(), now.getMonth(), now.getDate()].join('-');
        if (dateKey === lastDateKey) return;
        lastDateKey = dateKey;
        var dispatchDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        var remaining = days;
        while (remaining > 0) {
          dispatchDate.setDate(dispatchDate.getDate() + 1);
          if (!businessDays || (dispatchDate.getDay() !== 0 && dispatchDate.getDay() !== 6)) remaining -= 1;
        }
        var parts = new Intl.DateTimeFormat('en-AU', { weekday: 'short', day: 'numeric', month: 'short' }).formatToParts(dispatchDate);
        var values = {};
        parts.forEach(function (part) { values[part.type] = part.value; });
        if (format === 'weekday_month_day') output.textContent = values.weekday + ' ' + values.month + ' ' + values.day;
        else if (format === 'day_month') output.textContent = values.day + ' ' + values.month;
        else output.textContent = values.weekday + ' ' + values.day + ' ' + values.month;
        output.setAttribute('datetime', dispatchDate.getFullYear() + '-' + String(dispatchDate.getMonth() + 1).padStart(2, '0') + '-' + String(dispatchDate.getDate()).padStart(2, '0'));
      }

      renderDate();
      var timer = window.setInterval(function () {
        if (!root.isConnected) { window.clearInterval(timer); return; }
        renderDate();
      }, 60000);
    }

    root.querySelectorAll('[data-barefoot-size-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var selectedValue = select.value;
        var optionIndex = select.dataset.index;
        var matchingInput = Array.prototype.find.call(root.querySelectorAll('[data-variant-input][data-index="' + optionIndex + '"]'), function (input) {
          return input.value === selectedValue;
        });
        if (!matchingInput) return;
        matchingInput.checked = true;
        matchingInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    function selectedOptions() {
      var selected = {};
      root.querySelectorAll('[data-variant-input]').forEach(function (input) {
        var type = input.getAttribute('type');
        if ((type === 'radio' || type === 'checkbox') && !input.checked) return;
        selected[input.dataset.index] = input.value;
      });
      return selected;
    }

    function matchedVariant() {
      var selected = selectedOptions();
      return variants.find(function (variant) {
        return Object.keys(selected).every(function (index) {
          return variant[index] === selected[index];
        });
      }) || null;
    }

    function reconcileVariant() {
      if (!productSelect || !addToCartButton || !variants.length) return;
      var variant = matchedVariant();
      updateLowStock(variant);
      if (!variant) return;

      productSelect.value = String(variant.id);

      if (variant.available) {
        addToCartButton.disabled = false;
        addToCartButton.classList.remove('disabled');
        if (addToCartLabel) addToCartLabel.textContent = addToCartLabel.dataset.defaultText;

        root.querySelectorAll('[data-variant-input]:checked').forEach(function (input) {
          input.classList.remove('disabled');
          var label = input.parentElement ? input.parentElement.querySelector('label') : null;
          if (label) label.classList.remove('disabled');
        });
      }
    }

    root.querySelectorAll('[data-variant-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var linkedSelect = root.querySelector('[data-barefoot-size-select][data-index="' + input.dataset.index + '"]');
        if (linkedSelect && input.checked) linkedSelect.value = input.value;
        setTimeout(reconcileVariant, 0);
      });
    });
    reconcileVariant();
    initDispatchDate();
    var triggers = root.querySelectorAll('[data-barefoot-modal-open]');
    var modal = root.querySelector('[data-barefoot-modal]');
    if (!triggers.length || !modal) return;
    var dialog = modal.querySelector('[role="dialog"]');
    var closeButtons = modal.querySelectorAll('[data-barefoot-modal-close]');
    var lastFocus;
    function openModal() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.classList.add('barefoot-modal-open');
      dialog.focus();
    }
    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('barefoot-modal-open');
      if (lastFocus) lastFocus.focus();
    }
    triggers.forEach(function (trigger) { trigger.addEventListener('click', openModal); });
    closeButtons.forEach(function (button) { button.addEventListener('click', closeModal); });
    modal.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeModal();
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')).filter(function (el) { return !el.disabled; });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-barefoot-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
